import React from 'react';

interface ErrorDisplayProps {
  error: string | null;
  onRetry?: () => void;
  onDismiss?: () => void;
  variant?: 'error' | 'warning' | 'info';
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ 
  error, 
  onRetry, 
  onDismiss,
  variant = 'error'
}) => {
  if (!error) return null;
  
  const variantStyles = {
    error: {
      bg: '#fef2f2',
      border: '#fecaca',
      color: '#dc2626',
      icon: '⚠️',
    },
    warning: {
      bg: '#fffbeb',
      border: '#fde68a',
      color: '#d97706',
      icon: '⚡',
    },
    info: {
      bg: '#eff6ff',
      border: '#bfdbfe',
      color: '#2563eb',
      icon: 'ℹ️',
    },
  };
  
  const style = variantStyles[variant];
  
  return (
    <div style={{
      padding: '12px 16px',
      background: style.bg,
      color: style.color,
      border: `1px solid ${style.border}`,
      borderRadius: '8px',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
    }}>
      <span style={{ fontSize: '18px', flexShrink: 0 }}>{style.icon}</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: '500', marginBottom: onRetry || onDismiss ? '8px' : 0 }}>
          {error}
        </div>
        {(onRetry || onDismiss) && (
          <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
            {onRetry && (
              <button
                onClick={onRetry}
                style={{
                  padding: '4px 12px',
                  fontSize: '12px',
                  fontWeight: '600',
                  background: style.color,
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  transition: 'opacity 0.2s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                🔄 Retry
              </button>
            )}
            {onDismiss && (
              <button
                onClick={onDismiss}
                style={{
                  padding: '4px 12px',
                  fontSize: '12px',
                  fontWeight: '600',
                  background: 'transparent',
                  color: style.color,
                  border: `1px solid ${style.border}`,
                  borderRadius: '4px',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = `${style.color}10`}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
              >
                Dismiss
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorDisplay;
